import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title-hr',
  templateUrl: './title-hr.component.html',
  styleUrls: ['./title-hr.component.css'],
})
export class TitleHrComponent {
  @Input('title') title = '';
  @Input('id') id = '';
}
